import image1 from "./images/place images/1.png";
import image2 from "./images/place images/2.png";
import image3 from "./images/place images/3.png";
import image4 from "./images/place images/4.png";
import image5 from "./images/place images/5.png";
import image6 from "./images/place images/6.png";
import image7 from "./images/place images/7.png";
import image8 from "./images/place images/8.png";
import image9 from "./images/place images/9.png";
import image10 from "./images/place images/10.png";
import image11 from "./images/place images/11.png";
import image12 from "./images/place images/12.png";
import image13 from "./images/place images/13.png";
import image14 from "./images/place images/14.png";
import image15 from "./images/place images/15.png";
import image16 from "./images/place images/16.png";

const Data = [
  {
    image: image1,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 4,
  },
  {
    image: image2,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 3,
  },
  {
    image: image3,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 4,
  },
  {
    image: image4,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 2,
  },
  {
    image: image5,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 3,
  },
  {
    image: image6,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 1,
  },
  {
    image: image7,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 2,
  },
  {
    image: image8,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 0,
  },
  {
    image: image9,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 3,
  },
  {
    image: image10,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 1,
  },
  {
    image: image11,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 4,
  },
  {
    image: image12,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 2,
  },
  {
    image: image13,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 1,
  },
  {
    image: image14,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 3,
  },
  {
    image: image15,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 3,
  },
  {
    image: image16,
    name: "Desert king",
    price: "1MBT per night",
    distance: "2345km away",
    available: "available for 2 weeks stay",
    star: 1,
  },
];

export default Data;
